import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import GlobePage from './pages/GlobePage';
import SonarPage from './pages/SonarPage';
import OceanLayersPage from './pages/OceanLayersPage';
import CrewLogsPage from './pages/CrewLogsPage';
import AlertsPage from './pages/AlertsPage';
import AnalyticsPage from './pages/AnalyticsPage';
import MissionPlanningPage from './pages/MissionPlanningPage';
import WeatherForecastPage from './pages/WeatherForecastPage';
import BathymetryPage from './pages/BathymetryPage';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App" data-testid="app-root">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/globe" element={<GlobePage />} />
          <Route path="/sonar" element={<SonarPage />} />
          <Route path="/layers" element={<OceanLayersPage />} />
          <Route path="/logs" element={<CrewLogsPage />} />
          <Route path="/alerts" element={<AlertsPage />} />
          <Route path="/analytics" element={<AnalyticsPage />} />
          <Route path="/missions" element={<MissionPlanningPage />} />
          <Route path="/weather" element={<WeatherForecastPage />} />
          <Route path="/bathymetry" element={<BathymetryPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
